import React from 'react';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import { classes, style } from 'typestyle';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { important, px } from 'csx';
import { mediaSmallTablet } from '../utilities/mediaQueries';

interface LicenseValidationModalProps {
  show: boolean;
  onRequestClose(): void;
}

export const LicenseValidationModal: React.FC<LicenseValidationModalProps> = ({ show, onRequestClose }) => {
  return (
    <ScrollableOverlay className={styles.wrapper} show={show} onRequestClose={onRequestClose}>
      <div className={overlayStyles.header} style={{ padding: '0 0 24px' }}>
        <h3 className={classes(styles.heading, overlayStyles.title)}>License Valid for 5 years</h3>
      </div>
      <div className={styles.body}>
        <p className={styles.description}>
          Although unlikely, the rights holder can reclaim the rights to the music once the term ends, meaning that any
          new revenue from that point onwards could be claimed by the rights holder. In this rare case, you could
          purchase another license for the same track using Lickd and update the attribution copy in your video
          description. This will grant you the rights again for the license term.
        </p>

        <p className={styles.description}>
          You will always be able to keep any existing revenue that you&apos;ve earned from using a track licensed from
          Lickd.
        </p>
      </div>
    </ScrollableOverlay>
  );
};

const styles = {
  description: style({
    fontSize: '16px',
    marginBottom: spacing.LARGE,
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    textAlign: 'center',
    $nest: {
      '& > p': {
        margin: '0 0 1.5rem',
        textAlign: 'left',
        lineHeight: px(24),
      },
    },
  }),
  wrapper: style(
    mediaSmallTablet({
      padding: important('24px'),
    }),
    { display: 'block', maxWidth: px(440) }
  ),
  heading: style({
    fontSize: px(24),
  }),
};
